var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNetwork = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.259,
    height: 18,
    viewBox: "0 0 11.259 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.091,4.373a3.48,3.48,0,0,0-4.922,0l-.79-.791a4.6,4.6,0,0,1,6.5,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51,5.954a1.274,1.274,0,0,0-1.759,0l-.791-.79a2.362,2.362,0,0,1,3.341,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.588,2.792.8,2a6.833,6.833,0,0,1,9.664,0l-.79.79a5.716,5.716,0,0,0-8.084,0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.228,18l.631-1.387L5.634,13.1l3.751,3.473L10.031,18h1.228L6.138,6.742H5.121L0,18Zm6.958-4.055-1.732-1.6.7-.655ZM5.629,8.323l1.042,2.29-1.039.966-1.044-.967ZM4.1,11.685l.711.658L3.062,13.969Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNetwork);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/network.0387b34ae5ca8abd6702f645e08008fa.svg";